import React from "react";
import { Row, Col } from "antd";
import dayjs from "dayjs";
import styles from "./index.module.scss";
import { Middah } from "../../../../../hooks/api/middot";
import { dateFormatDisplay } from "../../../../../contstant";

interface OverviewSectionProps {
  data?: Middah;
}

export default function OverviewSection({
  data,
}: OverviewSectionProps): React.ReactElement | null {
  if (!data) return null;

  const items = [
    { label: "Name", value: data.name },
    {
      label: "Created Date",
      value: data.createdAt
        ? dayjs(data.createdAt).format(dateFormatDisplay)
        : "",
    },
    {
      label: "Last Update",
      value: data.updatedAt
        ? dayjs(data.updatedAt).format(dateFormatDisplay)
        : "",
    },
  ];

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Overview</h3>
      <Row gutter={[24, 0]}>
        {items.map((item) => (
          <Col key={item.label} span={6}>
            <div className={styles.item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
